<div class="timeline">
  <ng-content></ng-content>
</div>
